// extracted by mini-css-extract-plugin
export var aiStarIcon = "_c9-4";
export var closeButton = "_c9-6";
export var dismissButton = "_c9-3";
export var editImageWithAiContainer = "_c9-8";
export var imageUploadWrapper = "_c9-7";
export var misspelledWord = "_c9-5";
export var spellCheckContainer = "_c9-2";
export var spin = "_c9-1";
export var spinning = "_c9-0";